/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@ba-ui-toolkit/button';
import ToolTip from '@ba-ui-toolkit/tooltip';
import chevronDown16 from '@ba-ui-toolkit/ba-graphics/dist/icons-js/chevron-down_16';
import chevronUp16 from '@ba-ui-toolkit/ba-graphics/dist/icons-js/chevron-up_16';
import styles from './TimeSlot.scss';
import stringResource from './nls/StringResource';

const timeSlotClassName = styles.timeSlotClassName.replace(/"/g, '');

function getString(value) {
	return stringResource.get(value);
}

// TODO:duplicated
const HOURS = 11;
const MINUTES = 59;
const SECONDS = 59;
const TIMES = {
	h: 11,
	m: 59,
	s: 59,
	a: 1,
};
function convertNum(unit, num) {
	let numb = num;
	if (unit === 'h') {
		numb = parseInt(numb, 10) + 1;
	}
	if (numb < 10) {
		return 0 + numb.toString();
	}

	return numb;
}
export default class TimeSlot extends Component {
	static propTypes = {
		unit: PropTypes.oneOf(['h', 'm', 's', 'a']),
		onChange: PropTypes.func,
		index: PropTypes.number,
		getLocaleString: PropTypes.func,
	};

	static defaultProps = {
		getLocaleString: getString,
	};

	constructor(props) {
		super(props);
		this.increment = this.increment.bind(this);
		this.decrement = this.decrement.bind(this);
	}

	shouldComponentUpdate(nextProps) {
		const { unit, index } = nextProps;
		switch (true) {
			case index > TIMES[unit]:
				return false;
			case index < 0:
				return false;
			default:
		}

		return true;
	}

	increment(index) {
		const { onChange, unit } = this.props;
		const nextValue = index + 1;
		if (nextValue <= TIMES[unit]) {
			onChange(convertNum(unit, nextValue));
		} else {
			onChange(convertNum(unit, 0));
		}
	}
	decrement(index) {
		const { onChange, unit } = this.props;
		const lowestValue = 0;
		const nextValue = index - 1;
		if (nextValue >= lowestValue) {
			onChange(convertNum(unit, nextValue));
		} else {
			onChange(convertNum(unit, TIMES[unit]));
		}
	}

	_arrow(direction) {
		const iconProps = {
			variant: 'icon',
			intent: 'primary',
		};
		const { unit, index, getLocaleString } = this.props;
		const labelPrefix = direction === 'up' ? 'increase' : 'decrease';
		const clickHandler = direction === 'up' ? this.increment : this.decrement;
		const tooltipPos = direction === 'up' ? 'left' : 'bottom';
		const icon = direction === 'up' ? chevronUp16.id : chevronDown16.id;
		let toolipTitle =
			direction === 'up' ? getLocaleString('increment') : getLocaleString('decrement');
		let ariaLebel;
		switch (unit) {
			case 'h': {
				ariaLebel = getLocaleString(`${labelPrefix}Hour`);
				break;
			}
			case 'm': {
				ariaLebel = getLocaleString(`${labelPrefix}Minute`);
				break;
			}
			case 's': {
				ariaLebel = getLocaleString(`${labelPrefix}Second`);
				break;
			}
			case 'a': {
				toolipTitle = getLocaleString('changeAMPM');
				ariaLebel = toolipTitle;
				break;
			}
			default: {
				return null;
			}
		}

		return (
			<ToolTip orient={tooltipPos} title={toolipTitle}>
				<Button
					aria-label={ariaLebel}
					{...iconProps}
					icon={icon}
					onClick={() => {
						clickHandler(index);
					}}
				/>
			</ToolTip>
		);
	}

	render() {
		const { unit, index } = this.props;
		let times = [];
		switch (unit) {
			case 'h': {
				let h = 0;
				while (h <= HOURS) {
					// eslint-disable-next-line no-plusplus
					times.push(h++);
				}
				break;
			}
			case 'm': {
				let m = 0;
				while (m <= MINUTES) {
					// eslint-disable-next-line no-plusplus
					times.push(m++);
				}
				break;
			}
			case 's': {
				let s = 0;
				while (s <= SECONDS) {
					// eslint-disable-next-line no-plusplus
					times.push(s++);
				}
				break;
			}
			case 'a': {
				times = ['AM', 'PM'];
				break;
			}
			default: {
				return null;
			}
		}

		return (
			<div className={timeSlotClassName}>
				<div className={`${timeSlotClassName}__${unit}__up`}>{this._arrow('up')}</div>
				<div className={`${timeSlotClassName}__item prev`}>
					{convertNum(unit, times[index + 1]) || convertNum(unit, times[0])}
				</div>
				<div className={`${timeSlotClassName}__item current`}>
					{convertNum(unit, times[index])}
				</div>
				<div className={`${timeSlotClassName}__item next`}>
					{convertNum(unit, times[index - 1]) || convertNum(unit, times[TIMES[unit]])}
				</div>
				<div className={`${timeSlotClassName}__${unit}__down`}>{this._arrow('down')}</div>
			</div>
		);
	}
}
